<script >

export default {
    name: 'YearComponent',
    props: {
        year: {
            type: Array,
            required: true
        },
        activeYear: {
            type: [String, Number],
            required: false
        }
    },
    data() {
        return {

        }
    },
    methods: {
        openModalYear(){
            this.$bvModal.show('modalYear');
        },

        closeModalYear(){
            this.$bvModal.hide('modalYear');
        },
        selectYear(annee) {
            this.$emit('select-year', annee);
        }

    },
    computed: {


    },

    mounted() {

    }
}
</script>

<template>
    <b-modal
        id="modalYear"
        title="Sélectionner une année"
        size="md"
        hide-footer
        scrollable
        centered
    >
        <div class="row">
            <div
                class="col-6 col-md-4 mb-3"
                v-for="(y, index) in year"
                :key="index"
            >
                <b-card
                    class="text-center year-card"
                    body-class="p-3"
                    :class="{ selected: y.annee === activeYear }"
                    @click="selectYear(y.annee)"
                >
                    <h5 class="mb-0 font-weight-bold">{{ y.annee }}</h5>
                </b-card>
            </div>
        </div>
    </b-modal>
</template>

<style scoped>
/* Style de base de la carte */
.year-card {
    cursor: pointer;
    border: 2px solid #e9ecef; /* Bordure légère par défaut */
    border-radius: 12px;
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    background-color: #ffffff;
    overflow: hidden;
}

/* Effet au survol (Hover) */
.year-card:hover {
    border-color: #2d9b94;
    background-color: rgba(45, 155, 148, 0.05); /* Fond très léger de la couleur de base */
    transform: translateY(-4px); /* Soulèvement */
    box-shadow: 0 10px 20px rgba(45, 155, 148, 0.15); /* Ombre colorée douce */
}

/* Changement de couleur du texte au hover */
.year-card:hover h5 {
    color: #2d9b94;
}

/* Effet au clic (Active) */
.year-card:active {
    transform: scale(0.92); /* Effet d'enfoncement */
    background-color: #2d9b94;
    transition: all 0.1s;
}

.year-card:active h5 {
    color: white;
}

/* Optionnel : Style si l'année est sélectionnée (si vous passez une prop activeYear) */
.year-card.selected {
    background-color: #2d9b94;
    border-color: #2d9b94;
    color: white;
}
</style>

